/**
 * Sparkline geometry shared by `sh-kpi-card` and the legacy dashboard card.
 * The drawing area is a 100 x 40 viewBox; values are scaled to the maximum
 * (minimum 1, so an all-zero series draws a flat line) with a 2px margin.
 * Fewer than two values draw nothing.
 */
export const SPARKLINE_WIDTH = 100;
export const SPARKLINE_HEIGHT = 40;

export function sparklinePoints(
  values: readonly number[] | null | undefined
): [number, number][] {
  const counts = values ?? [];
  const n = counts.length;
  if (n < 2) {
    return [];
  }

  const max = Math.max(...counts, 1);
  return counts.map((count, i) => {
    const x = (i / (n - 1)) * SPARKLINE_WIDTH;
    const y = SPARKLINE_HEIGHT - (count / max) * 36 - 2;
    return [x, y] as [number, number];
  });
}

/** `points` attribute for a `<polyline>`; empty string when there is nothing to draw. */
export function sparklineLine(
  values: readonly number[] | null | undefined
): string {
  return sparklinePoints(values)
    .map(([x, y]) => `${x},${y}`)
    .join(' ');
}

/** `d` attribute for the filled area under the line; empty string when there is nothing to draw. */
export function sparklineArea(
  values: readonly number[] | null | undefined
): string {
  const points = sparklinePoints(values);
  if (!points.length) {
    return '';
  }

  const line = points.map(([x, y]) => `L${x},${y}`).join(' ');
  return `M0,${SPARKLINE_HEIGHT} ${line} L${SPARKLINE_WIDTH},${SPARKLINE_HEIGHT} L0,${SPARKLINE_HEIGHT} Z`;
}
